import React from 'react'
import { RightDrawer } from '@/shared/ui/RightDrawer'
import OportunidadesFilterControls from './OportunidadesFilterControls'

export default function OportunidadesFilterDrawer({ open, onOpenChange }: { open: boolean; onOpenChange: (v: boolean) => void }) {
  return (
    <RightDrawer open={open} onOpenChange={onOpenChange} title="Filtrar oportunidades" className="w-[90%] max-w-[450px]">
      <OportunidadesFilterControls showHeader />
    </RightDrawer>
  )
}
